export const isCurrentType = (type, currentType) => (type === currentType);
